import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { TollAndFuelCalculatorConfig } from "./AddTollAndFuelCalculator.config";
import Reactportal from "../../Reactportal/Reactportal";
import PortalFooter from "../../Reactportal/PortalFooter";
import { useLazyQuery } from "@apollo/client";
import { checkFormErrors } from "../../../custom_hooks/useCheckFormError";
import { ErrorToast } from "../../ToastComponent/RectHotToast";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import Addloadsection from "../AddLoad/Addloadsection/Addloadsection";
import { MapContainer, Marker, Polyline, Tooltip } from "react-leaflet";
import { OlaTileLayer } from "../AddMyShipmentTracking/components/TrackingMap/components/TileLayer";
import { FullscreenControl } from "../AddMyShipmentTracking/components/TrackingMap/components/FullScreenControl";
import "./AddTollAndFuelCalculator.scss";
import { iconDes, iconOriginO, locationIcon } from "../AddMyShipmentTracking/components/TrackingMap/components/Ions";
import Loading from "../../Loading/Loading";
import { Tabs } from "../../AdminRequestSupportComponents/Tabs";
import { getTollDetailsQuery } from "../../../../Utils/AllPagesQuriesAndMutations";
import { FaRupeeSign } from "react-icons/fa";
import { useModalContext } from "../../Reactportal/ModalContext";

const AddTollAndFuelCalculator = ({ show, TypeOfPortal = "Add" }) => {
  const Form_Key = "Toll_Fuel_Calculator";
   const { pushModal, popModal } = useModalContext();
  const [toggle, settoggle] = useState(show ? show : true);
  const [isFirstLoad, setFirstLoad] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const dispatch = useDispatch();
  const [FormData, setFormData] = useState({});
  const [origin, setOrigin] = useState({ cityName: "", latAndLng: [] });
  const [destination, setDestination] = useState({ cityName: "", latAndLng: [] });
  const [flag, setFlag] = useState(false);
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);
  const defaultCenter = [20.5937, 78.9629];
  const [center, setCenter] = useState(defaultCenter);
  const [route, setRoute] = useState([]);
  const [summary, setSummary] = useState({});
  const [options, setOptions] = useState([]);
  const Tab = useSelector((store) => store.SelectedTabData.tab);
  const [activeOption, setActiveOption] = useState(0);
  const [polyLineData, setPolyLineData] = useState([]);


  function getFirstDigit(s) {
    const match = s.match(/\d/);
    return match ? parseInt(match[0]) : null;
  }

  const [fetchTollDetails, { loading: getTollDetailsLoading }] = useLazyQuery(getTollDetailsQuery, {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };

  const Validate_handleSubmit = (submit) => {
    const Error = checkFormErrors(formErrors);
    if (!Error) {
      submit();
    }
  };

  useEffect(() => {
    if (FormDataFromRedux && FormDataFromRedux.hasOwnProperty(Form_Key)) {
      setFormData(FormDataFromRedux[Form_Key].Toll_And_Fuel_Calculator_Details);
    }
  }, [FormDataFromRedux]);

  const submit = async () => {
    setOptions([]);
    setFlag(true);
    setCenter([20.5937, 78.9629]);
    let data = FormDataFromRedux?.MasterData[Form_Key];
    setOrigin({ cityName: data?.From_City?.name, latAndLng: [data?.From_City?.Latitude, data?.From_City?.Longitude] });
    setDestination({ cityName: data?.To_City?.name, latAndLng: [data?.To_City?.Latitude, data?.To_City?.Longitude] });
    await fetchTollDetails({
      variables: {
        userInput: {
          from: {
            longitude: data?.From_City?.Longitude,
            latitude: data?.From_City?.Latitude,
          },
          to: {
            latitude: data?.To_City?.Latitude,
            longitude: data?.To_City?.Longitude,
          },
          vehicleData: {
            type: FormData?.vehicle_Type,
            axles: getFirstDigit(FormData?.vehicle_Type),
          },
        },
      },
    })
      .then((res) => {
        if (res.data.getTollDetails.data.doc.routes.length > 0) {
          const routesData = res.data.getTollDetails.data.doc.routes;
          const summaryData = res.data.getTollDetails.data.doc.summary;
          setRoute(routesData || []);
          setSummary(summaryData || {});
          const optionsCount = routesData.length;
          setOptions((currentOptions) => {
            const newOptions = [];
            for (let i = 0; i < optionsCount; i++) {
              newOptions.push({ id: i + 1, name: `Option_${i + 1}` });
            }
            return [...currentOptions, ...newOptions];
          });
          dispatch({ type: "TabData", payload: { tab: "Option_1" } });
          setActiveOption(0);
        }
      })
      .catch((error) => {
        setRoute([]);
        ErrorToast("Error in fetching toll data");
      });
  };

  useEffect(() => {
    const index = parseInt(Tab.split("_")[1]) - 1;
    setActiveOption(index);
  }, [Tab]);

  useEffect(() => {
    if (!getTollDetailsLoading && route.length > 0 && route[activeOption] && route[activeOption].tolls) {
      const polylinePositions = [];

      if (origin.latAndLng.length === 2) {
        polylinePositions.push(origin.latAndLng);
      }

      const tollPoints = route[activeOption].tolls
        .filter((toll) => toll.lat && toll.lng)
        .map((toll) => [toll.lat, toll.lng]);
      polylinePositions.push(...tollPoints);

      if (destination.latAndLng.length === 2) {
        polylinePositions.push(destination.latAndLng);
      }
      setPolyLineData(polylinePositions);
    }
  }, [getTollDetailsLoading, route, activeOption]);

    useEffect(() => {
      pushModal(Form_Key);
      return () => {
        popModal(Form_Key);
      };
    }, []);
  

  const Closeformfunction = () => {
    settoggle(false);
    ClearSpecificForm(dispatch, Form_Key);
  };

  const handleCalculateSubmit = () => {
    Validate_handleSubmit(submit);
  };
  const calculateFuelCost = (distance, fuel, hwy, fuelPrice) => {
    const distanceInKm = distance / 1000;
    const totalFuelNeeded = (distanceInKm / hwy) * (fuelPrice - 10);
    return Math.round(totalFuelNeeded);
  };
  return (
    <div>
      <Reactportal
        open={toggle}
        onClose={Closeformfunction}
        TypeOfPortal={"Toll & Fuel calculator"}
        TypeOfId={"Account Id :"}
      >
        <div className="Toll_Fuel_Calculator">
          {TollAndFuelCalculatorConfig.map((e) => {
            return (
              <div key={e.id} style={{ margin: "10px" }}>
                {TollAndFuelCalculatorConfig &&
                  TollAndFuelCalculatorConfig.map((e) => {
                    return (
                      <Addloadsection
                        inputfields={e.fields}
                        Type={e.name}
                        BidType=""
                        TypeOfPortal={TypeOfPortal}
                        formkey={Form_Key}
                        onErrorsChange={handleErrorsChange}
                        handleCalculateFunction={handleCalculateSubmit}
                        CalculateButtonShow={true}
                      />
                    );
                  })}
              </div>
            );
          })}
          {options.length > 0 && (
            <div className="Options_Tab_Container">
              <Tabs tabs={options} />
            </div>
          )}
          {flag && (
            <div className="tracking-map">
              <div className="map-container">
                <MapContainer center={center} zoom={6} scrollWheelZoom={false}>
                  <OlaTileLayer />
                  <Marker position={origin.latAndLng} icon={iconOriginO}>
                    <Tooltip permanent={false} interactive={true} className="trip_tooltip">
                      <div className="trip_tooltip_content">
                        <div className="ping_number">Starting Point</div>
                        <div className="ping_number">Name : {origin.cityName}</div>
                      </div>
                    </Tooltip>
                  </Marker>
                  {!getTollDetailsLoading &&
                    route.length > 0 &&
                    route[activeOption].tolls &&
                    route[activeOption].tolls.map((el, index) => {
                      const { lat, lng, name } = el.start || el;

                      if (lat && lng) {
                        return (
                          <Marker position={[lat, lng]} icon={locationIcon} key={index}>
                            <Tooltip permanent={false} interactive={true} className="trip_tooltip">
                              <div className="trip_tooltip_content">
                                <div className="ping_number">Name : {name}</div>
                                <div className="ping_number">
                                  Cost : <FaRupeeSign size={"11px"} /> {el.tagCost.toLocaleString("en-US")}/-
                                </div>
                              </div>
                            </Tooltip>
                          </Marker>
                        );
                      }
                      return null;
                    })}

                  <Marker position={destination.latAndLng} icon={iconDes}>
                    <Tooltip permanent={false} interactive={true} className="trip_tooltip">
                      <div className="trip_tooltip_content">
                        <div className="ping_number">Destination Point</div>
                        <div className="ping_number">Name : {destination.cityName}</div>
                      </div>
                    </Tooltip>
                  </Marker>
                  <FullscreenControl />
                  {!getTollDetailsLoading && route.length > 0 && route[activeOption].tolls && (
                    <Polyline
                      positions={polyLineData}
                      color="gray"
                      weight={3}
                      dashArray="5,5" // Dotted line
                    />
                  )}
                </MapContainer>
              </div>

              <div className="Details_Container">
                <div className="Travel_Distance_duration_Costing">
                  {!getTollDetailsLoading && route.length > 0 && route[activeOption].summary && (
                    <>
                      <div>
                        Distance :{" "}
                        <span className="Travel_Info">{route[activeOption].summary.distance.metric || "-"}</span>
                      </div>
                      <div>
                        Duration :{" "}
                        <span className="Travel_Info">{route[activeOption].summary.duration.text || "-"}</span>
                      </div>
                    </>
                  )}
                  {!getTollDetailsLoading && route.length > 0 && route[activeOption].costs && (
                    <>
                      <div>
                        Fuel Cost :{" "}
                        <span className="Travel_Info">
                          {route[activeOption].summary.distance.value ? (
                            <>
                              <FaRupeeSign size={"13px"} />
                              {calculateFuelCost(
                                route[activeOption].summary.distance.value,
                                route[activeOption].costs.fuel,
                                summary.fuelEfficiency.hwy,
                                summary.fuelPrice.value
                              ).toLocaleString("en-US")}
                            </>
                          ) : (
                            "-"
                          )}
                        </span>
                      </div>
                      <div>
                        Toll Cost :{" "}
                        <span className="Travel_Info">
                          <FaRupeeSign size={"13px"} />
                          {route[activeOption].costs.tagAndCash.toLocaleString("en-US") || "-"}
                        </span>
                      </div>
                    </>
                  )}
                </div>
                <div className="Toll_Tax_BreakUp_Container">
                  {!getTollDetailsLoading && route.length > 0 && (
                    <div className="Toll_Tax_Breakup_Tile">
                      Toll Tox Breakup (Toll plaza - {route[activeOption].tolls.length})
                    </div>
                  )}
                  {getTollDetailsLoading && <Loading />}
                  {!getTollDetailsLoading && route.length === 0 && (
                    <div className="Data_Not_Available_Container">
                      <h5>Data not available</h5>
                    </div>
                  )}
                  {!getTollDetailsLoading && route.length > 0 && route[activeOption].tolls && (
                    <div className="Toll_Points_Container">
                      {route[activeOption].tolls.map((el, index) => {
                        const tollName = el.name || el.start?.name || "Unknown";

                        return (
                          <div className="Toll_Point_Item" key={index}>
                            <div>
                              <span className="Toll_Point_Name"> Name : </span>
                              {tollName}
                            </div>
                            <div>
                              <span className="Toll_Point_Cost">Cost : </span>
                              <FaRupeeSign size={"12px"} /> {el.tagCost.toLocaleString("en-US")}/-
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          Form_key={Form_Key}
          handleformclose={() => {
            Closeformfunction();
          }}
          loadingState={false}
        />
      </Reactportal>
    </div>
  );
};

export default AddTollAndFuelCalculator;
